import React from 'react';
import _range from 'lodash/range';

// Styles
import './ColorRange.scss';

function ColorRange({
  set,
  colorRange,
  colorRangeSteps,
}: {
  set: number;
  colorRange: string[];
  colorRangeSteps: number;
}) {
  const rangeList = _range(colorRangeSteps + 1);

  return (
    <>
      {rangeList &&
        colorRange.map((color: string, index: number) => {
          if (colorRangeSteps > index) {
            return (
              <span
                key={index}
                className={`color-range set${set} color${index}`}
                style={{ backgroundColor: color, width: `calc( 100% / ${colorRangeSteps})` }}
              />
            );
          }
        })}
    </>
  );
}

export default ColorRange;
